import React from 'react';
import Icon from '@ant-design/icons';

export { QuestionCircleOutlined as HelpIcon } from '@ant-design/icons';

import ArchiveSvg from '../../../../img/icons/svg/archive.svg';
import CheckedSvg from '../../../../img/icons/svg/checked.svg';
import EditSvg from '../../../../img/icons/svg/edit.svg';
import PhoneOldSvg from '../../../../img/icons/svg/phone-old.svg';
import TrashSvg from '../../../../img/icons/svg/trash.svg';
import UserSvg from '../../../../img/icons/svg/user.svg';
import RestoreSvg from './material-symbols-restore-from-trash.svg';

type IconType = React.FC<React.ComponentProps<typeof Icon>>;
export {
  ShareAltOutlined as AppealSourceIcon,
  PaperClipOutlined as AttachmentIcon,
  BellOutlined as BellIcon,
  ArrowLeftOutlined as ChatIncomingIcon,
  ArrowUpOutlined as ChatOutgoingIcon,
  MessageFilled as ChatUnreadIcon,
  CheckOutlined as CheckIcon,
  CloseCircleOutlined as ClearIcon,
  ClockCircleOutlined as ClockIcon,
  MessageOutlined as CommentIcon,
  PlusOutlined as CreateIcon,
  DownloadOutlined as DownloadIcon,
  HeartOutlined as HeartOutlinedIcon,
  EyeInvisibleOutlined as HideIcon,
  MinusOutlined as MinusIcon,
  MoreOutlined as MoreMenuIcon,
  TeamOutlined as OfficeMeetingIcon,
  VideoCameraOutlined as OnlineMeetingIcon,
  HomeOutlined as ProjectIcon,
  ReloadOutlined as ReloadIcon,
  RollbackOutlined as RollbackIcon,
  StopOutlined as StopIcon,
  CarryOutOutlined as TaskIcon,
  KeyOutlined as UnitIcon,
  DashboardOutlined as UnprocessedIcon,
  UserOutlined as UserIconAlt,
  EyeOutlined as ViewIcon,
  ExclamationCircleFilled as WarningIcon,
} from '@ant-design/icons';

export const ArchiveIcon: IconType = (props) => (
  <Icon {...props} component={ArchiveSvg} />
);

export const UserIcon: IconType = (props) => (
  <Icon {...props} component={UserSvg} />
);

export const EditIcon: IconType = (props) => (
  <Icon {...props} component={EditSvg} />
);

export const DeleteIcon: IconType = (props) => (
  <Icon {...props} component={TrashSvg} />
);

export const RestoreIcon: IconType = (props) => (
  <Icon {...props} component={RestoreSvg} />
);

export const PhoneIcon: IconType = (props) => (
  <Icon {...props} component={PhoneOldSvg} />
);

export const CheckedIcon: IconType = (props) => (
  <Icon {...props} component={CheckedSvg} />
);

const MiCall = () => (
  <i className="material-icons material-icons-outlined md-18">call</i>
);

export const CallIcon: IconType = (props) => (
  <Icon {...props} component={MiCall} />
);

const MiSipCall = () => (
  <i className="material-icons material-icons-outlined md-18">dialer_sip</i>
);

export const SipCallIcon: IconType = (props) => (
  <Icon {...props} component={MiSipCall} />
);

const MiMergeLead = () => <i className="material-icons">close_fullscreen</i>;

export const MergeLeadIcon: IconType = (props) => (
  <Icon {...props} component={MiMergeLead} />
);
